import AttivitaForm from '../attivita/AttivitaForm';

interface Props {
  leadId: string;
  onCreated?: () => void;
}

export default function LeadQuickActivityForm({ leadId, onCreated }: Props) {
  return (
    <AttivitaForm
      context={{ kind: 'lead', id: leadId }}
      onSuccess={() => onCreated?.()}
    />
  );
}
